import { useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { useStringsContext } from '../contexts/strings';

export interface ValidateData {
  validFeed: boolean;
  validImage: boolean;
  validTitle: boolean;
  validLink: boolean;
}

export const useRSSValidate = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { strings } = useStringsContext();

  const validateUrl = useCallback(
    async (rssUrl: string): Promise<ValidateData | null> => {
      let data: ValidateData | null = null;

      try {
        const encodedRssurl = encodeURIComponent(rssUrl);
        const response = await fetch(
          `${process.env.REACT_APP_NEWSRSS_APIURL}/validaterss?url=${encodedRssurl}`
        );

        if (!response.ok) {
          throw new Error(`Validate RSS failed! (${response.status})`);
        }
        data = await response.json();
      } catch (error) {
        console.error(error);
        enqueueSnackbar(strings.messages.validateError, {
          variant: 'error',
        });
        throw error;
      }

      return data;
    },
    [enqueueSnackbar, strings]
  );

  return validateUrl;
};
